const CTA_TYPE_DEFAULT = 'DEFAULT';
const CTA_TYPE_RESUME_SUBSCRIPTION = 'RESUME_SUBSCRIPTION';
const CTA_TYPE_UPDATE_PAYMENT = 'UPDATE_PAYMENT';
const CTA_TYPE_UPGRADE_PLAN = 'UPGRADE_PLAN';

const CTA_DESCRIPTION = {
    [CTA_TYPE_RESUME_SUBSCRIPTION]: 'resume',
    [CTA_TYPE_UPDATE_PAYMENT]: 'update',
    [CTA_TYPE_UPGRADE_PLAN]: 'upgrade',
};

export default class FlexibleHeaderCTATracking {
    constructor(ctaType = CTA_TYPE_DEFAULT) {
        this.setCTAType(ctaType);
    }

    setCTAType(ctaType) {
        if (typeof ctaType !== 'string') {
            this.ctaType = CTA_TYPE_DEFAULT;
        } else {
            this.ctaType = ctaType.trim() || CTA_TYPE_DEFAULT;
        }
    }

    /**
     * Retrieves the CTA click trackAction values based on the ctaType.
     *
     * @returns {Object} An object containing the `menuItemLabel` if available, otherwise an empty object.
     */
    getCTAClickValues() {
        const menuItemLabel = CTA_DESCRIPTION[this.ctaType];
        return menuItemLabel ? { menuItemLabel } : {};
    }
    /**
     * Retrieves the tooltip hover trackAction values based on the ctaType.
     *
     * @returns {Object} An object containing the `tooltipType` if available, otherwise an empty object.
     */
    getTooltipHoverValues() {
        const tooltipType = CTA_DESCRIPTION[this.ctaType];
        return tooltipType ? { tooltipType } : {};
    }
}
